export const getDocument = {
    source: 'data',
    route: '/document/documents/:documentId',
    method: 'GET',
};
